export {FbLogoSvg} from "./fb-logo";
export {PlayerBackward} from "./player-backward";
export {PlayerForward} from "./player-forward";
export {RrbLogoSvg} from "./rrb-logo";
export {RrbLogoWhiteSvg} from "./rrb-logo-white";
export {SondageSvg} from "./sondage";
export {XLogoSvg} from "./x-logo";
export {YtLogoSvg} from "./yt-logo";